import CreditCard from './NavIcons/CreditCard.svg';
import faq from './NavIcons/faq.svg';
import LinkedAccounts from './NavIcons/LinkedAccounts.svg';
import notification from './NavIcons/notification.svg';
import star from './NavIcons/star.svg';
import user from './NavIcons/user.svg';
import wifi from './NavIcons/wifi.svg';
import wrench from './NavIcons/wrench.svg';
import bell from './bell.svg';
import chatIcon from './chatIcon.svg';
import widgets from './widgets.svg';
import circleMinus from './circleMinus.svg';
import circlePlus from './circlePlus.svg';
import questionBubble from './questionBubble.svg';
import profilePlaceholder from './profile-placeholder.svg';
import propertyPlaceholder from './property_placeholder.svg';
import dollar from './dollar.svg';
import sendInvitation from './send-invitation.svg';
import refresh from './refresh.svg';
import pay from './pay.svg';
import informationCircle from './information-circle.svg';
import connection from './connections.svg';
import emptyInbox from './empty-inbox.svg';
import document from './document.svg';
import calendar from '../admin/calendar.svg';
import location from '../admin/location.svg';
import clock from '../admin/CommunityResourceIcons/clock.svg';
import group from '../admin/group.svg';
import check from './check.svg';
import noEventsIcon from './NoEventsIcon.svg';
import warning from '../admin/CommunityResourceIcons/warning.svg';
import house from './house.svg';
import chevronRight from '../admin/chevron-right.svg';
import trash from './trash.svg';
import amexIcon from './cards/amexIcon.svg';
import dinersIcon from './cards/dinersIcon.svg';
import discoverIcon from './cards/discoverIcon.svg';
import jcbIcon from './cards/jcbIcon.svg';
import maestroIcon from './cards/maestroIcon.svg';
import masterCardIcon from './cards/masterCardIcon.svg';
import unionPayIcon from './cards/unionPayIcon.svg';
import visaIcon from './cards/visaIcon.svg';
import padLock from './padlock.svg';
import bank from './bank.svg';
import magnifyingGlass from '../admin/magnifyingGlass.svg';
import handWrench from './hand-wrench.svg';
import speed from './speed.svg';
import emptyConversation from './emptyConversation.svg';
import resioLogoFaded from './resio-logo-faded.svg';
import board from '../admin/CommunityResourceIcons/board.svg';
import cbxLogo from './cbx_logo.svg';
import emailBubble from './email_bubble.svg';
import chatBubble from './chat_bubble.svg';
import property from '../admin/property.svg';
import cog from './cog.svg';
import emptyMessage from '../admin/emptyMessage.svg';
import chatSendActiveButton from './chat_send_active_button.svg';
import chatSendInactiveButton from './chat_send_inactive_button.svg';
import chevronDown from '../admin/chevron-down.svg';
import chevronUp from '../admin/chevron-up.svg';
import supermarket from './supermarket.svg';
import homePage from './home-page.svg';
import finish from './finish.svg';
import delivery from './delivery.svg';
import conversation from './conversation.svg';
import marketplaceStar from './marketplace-star.svg';
import startConvo from './start-convo.svg';
import emptySold from './empty-sold.svg';
import replyArrow from './reply-arrow.svg';
import threeDots from './three-dots.svg';
import emptyCard from './empty-card.svg';
import pendingCheck from './pending-check.svg';
import successCheck from '../admin/check-circle.svg';
import xFailed from './x-failed.svg';
import apple from './apple.svg';
import maintenace from './maintenance.svg';
import noConnection from './no-connection.svg';
import send from './send.svg';
import paperclip from '../admin/paperclip.svg';
import celebration from './celebration.svg';
import starGray from './star-gray.svg';
import chevronLeft from '../admin/chevron-left.svg';
import cancelX from '../admin/Cancel_X.svg';
import moon from './moon.svg';

export const RESIDENTS_SVG_COMPONENTS = {
    CREDIT_CARD: CreditCard,
    FAQ: faq,
    LINKED_ACCOUNTS: LinkedAccounts,
    NOTIFICATION: notification,
    STAR: star,
    USER: user,
    WIFI: wifi,
    WRENCH: wrench,
    BELL: bell,
    CHAT_ICON: chatIcon,
    WIDGETS: widgets,
    CIRCLE_MINUS: circleMinus,
    CIRCLE_PLUS: circlePlus,
    QUESTION_BUBBLE: questionBubble,
    PROFILE_PLACEHOLDER: profilePlaceholder,
    PROPERTY_PLACEHOLDER: propertyPlaceholder,
    DOLLAR: dollar,
    SEND_INVITATION: sendInvitation,
    REFRESH: refresh,   
    PAY: pay,
    INFORMATION_CIRCLE: informationCircle,
    CONNECTION: connection,
    EMPTY_INBOX: emptyInbox,
    DOCUMENT: document,
    CALENDAR: calendar,
    LOCATION: location,
    CLOCK: clock,
    GROUP: group,
    CHECK: check, 
    NO_EVENTS_ICON: noEventsIcon,
    WARNING: warning,
    HOUSE: house,
    CHEVRON_RIGHT: chevronRight,
    TRASH: trash,
    cards: {
      AMEX: amexIcon,
      DINERS: dinersIcon,
      DISCOVER: discoverIcon,
      JCB: jcbIcon,
      MAESTRO: maestroIcon,
      MASTERCARD: masterCardIcon,
      UNIONPAY: unionPayIcon,
      VISA: visaIcon,
    },
    PADLOCK: padLock,
    BANK: bank,
    MAGNIFYING_GLASS: magnifyingGlass,
    HAND_WRENCH: handWrench,
    SPEED: speed,
    EMPTY_CONVERSATION: emptyConversation,
    RESIO_LOGO_FADED: resioLogoFaded,
    BOARD: board,
    CBX_LOGO: cbxLogo,
    EMAIL_BUBBLE: emailBubble,
    CHAT_BUBBLE: chatBubble,  
    PROPERTY: property,
    COG: cog,
    EMPTY_MESSAGE: emptyMessage,
    CHAT_SEND_ACTIVE_BUTTON: chatSendActiveButton,
    CHAT_SEND_INACTIVE_BUTTON: chatSendInactiveButton,
    CHEVRON_DOWN: chevronDown,
    CHEVRON_UP: chevronUp,
    SUPERMARKET: supermarket,
    HOME_PAGE: homePage,
    FINISH: finish,
    DELIVERY: delivery,
    CONVERSATION: conversation,
    MARKETPLACE_STAR: marketplaceStar,
    START_CONVO: startConvo,
    EMPTY_SOLD: emptySold,
    REPLY_ARROW: replyArrow,
    THREE_DOTS: threeDots,
    APPLE: apple,
    EMPTY_CARD: emptyCard,
    PENDING_CHECK: pendingCheck,
    SUCCESS_CHECK: successCheck,
    X_FAILED: xFailed,
    MAINTENANCE: maintenace,
    NO_CONNECTION: noConnection,
    SEND: send,
    PAPERCLIP: paperclip,
    CELEBRATION: celebration,
    STAR_GRAY: starGray,
    CHEVRON_LEFT: chevronLeft,
    CANCEL_X: cancelX,
    MOON: moon,
  } as const;